import { z } from 'zod';

/**
 * Ghost text data schema for QuickFind search input placeholder.
 * Used to persist and restore dynamic placeholder text across sessions.
 */
export const ghostTextDataSchema: z.ZodObject<
	{
		/** The placeholder text to display */
		text: z.ZodString;
		/** Number of times this text has been shown (0-2, resets after 3) */
		occurrence: z.ZodDefault<z.ZodOptional<z.ZodNumber>>;
	},
	'strip',
	z.ZodTypeAny,
	{
		text: string;
		occurrence: number;
	},
	{
		text: string;
		occurrence?: number | undefined;
	}
> = z.object({
	/** The placeholder text to display */
	text: z.string(),
	/** Number of times this text has been shown (0-2, resets after 3) */
	occurrence: z.number().optional().default(0),
});
